/* Photo tile sets: empty tiles say "Upload your image" and open the file picker when tapped; single-file picker fix (2026-11-01). */
(function () {
  function fix() {
    var root = document.getElementById('gts'); if (!root) return;
    [].forEach.call(root.querySelectorAll('.ph'), function (ph) {
      var bi = ph.style.backgroundImage || '';
      if (bi.indexOf('data:image/svg') > -1) {
        ph.setAttribute('data-upl', '1'); ph.style.backgroundImage = 'none';
        if (!ph.querySelector('.upl')) { var s = document.createElement('span'); s.className = 'upl'; s.textContent = 'Upload your image'; ph.appendChild(s); }
      } else if (ph.hasAttribute('data-upl') && bi && bi !== 'none') {
        ph.removeAttribute('data-upl'); var u = ph.querySelector('.upl'); if (u) u.remove();
      }
    });
    [].forEach.call(root.querySelectorAll('button'), function (b) { if (b.textContent === 'Continue with samples') b.textContent = 'Continue'; });
  }
  /* the page's own handlers clear the input before reading it, which empties the list: give them a copy */
  function safeInput(id, tries) {
    var el = document.getElementById(id); if (!el) return;
    if (!el.onchange) { if ((tries || 0) < 50) setTimeout(function () { safeInput(id, (tries || 0) + 1); }, 100); return; }
    var orig = el.onchange; el.onchange = null;
    el.addEventListener('change', function () {
      var arr = [].slice.call(el.files); if (!arr.length) return;
      var fake = { target: { files: arr, value: '' } };
      el.value = '';
      orig.call(el, fake);
    });
  }
  function start() {
    var root = document.getElementById('gts'); if (!root) return;
    safeInput('gts-one'); safeInput('gts-wallPhoto');
    fix(); new MutationObserver(fix).observe(root, { childList: true, subtree: true });
    var down = null;
    root.addEventListener('pointerdown', function (e) { var t = e.target.closest ? e.target.closest('.tile') : null; var n = t && t.querySelector('.n'); down = { x: e.clientX, y: e.clientY, empty: !!(t && t.querySelector('.ph[data-upl]')), n: n ? n.textContent : null, handle: !!(e.target.closest && e.target.closest('.drag')) }; }, true);
    root.addEventListener('pointerup', function (e) {
      var d = down; down = null;
      if (!d || !d.empty || d.handle || !d.n) return;
      if (Math.abs(e.clientX - d.x) > 8 || Math.abs(e.clientY - d.y) > 8) return;
      setTimeout(function () {
        var sel = root.querySelector('.tile.sel .n');
        var one = document.getElementById('gts-one');
        if (one && sel && sel.textContent === d.n) one.click();
      }, 0);
    }, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
